"use client";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import Link from "next/link";
import CommonImage from "../commonImage/commonImage.component";
import RichText from "../richText/richText.component";

interface ProcessStepsSectionProps {
  title?: string; // Array of process steps
  description?: string; // Description of the section
  steps?: ProcessStep[]; // Array of process steps
  showButton?: boolean; // "Get started now" under the description
}

export default function StepsSection({
  steps = [],
  title = "Steps",
  description = "Follow Steps",
  showButton = true,
}: ProcessStepsSectionProps) {
  return (
    <section className="py-20 sm:py-30 ">
      <div className="scontainer flex flex-col items-start gap-10  w-full ">
        <div className="flex flex-col items-center gap-6 w-full">
          <div className="flex justify-center items-center gap-2 self-stretch">
            <h2 className="w-full max-w-100 sm:max-w-140 md:max-w-180 font-semibold  text-center">
              {title}
            </h2>
          </div>

          <p className="w-full max-w-100 font-normal text-muted-2-foreground  items-center text-center">
            <RichText text={description} />
          </p>
          {showButton && (
            <div className="flex flex-col items-center gap-4 w-full max-w-[400px]">
              <Link
                target="_blank"
                href={`https://play.google.com/store/apps/details?id=com.letsdevelopit.lfydnewapp`}
              >
                <Button className="px-4 py-3">
                  <span className="font-bold text-base leading-6 whitespace-nowrap">
                    Get started now
                  </span>
                </Button>
              </Link>
            </div>
          )}
        </div>

        <div className="flex flex-col md:grid grid-cols-3 flex-wrap md:gap-4 gap-10 w-full">
          {steps.map((step) => (
            <Card
              key={step.id}
              className="flex flex-col gap-3 justify-center items-center border-none shadow-none m-0 bg-gray-50"
            >
              {/* Icon */}
              <div className="flex items-center justify-center p-5 md:p-3 md:border-4 bg-primary/10 text-primary border-solid border-primary rounded-full">
                <CommonImage
                  width={24}
                  height={24}
                  src={step.iconUrl}
                  alt={step.title}
                  className="size-7"
                />
              </div>

              {/* Content */}
              <CardContent className="flex flex-col gap-3 items-center text-center  w-full h-full justify-start p-4">
                {/* Step Label */}
                <p className="font-semibold text-muted-2-foreground tracking-wider">
                  STEP {step.id}
                </p>

                {/* Title + Description */}
                <div className="flex flex-col gap-3 items-center text-center w-full ">
                  <h3 className=" font-medium w-auto max-w-70 xl:max-w-80 text-[16px] xs:text-[18px] sm:text-[22px] leading-[130%]">
                    {step.title}
                  </h3>
                  <p className="text-muted-2-foreground  sm:max-w-[300px] max-w-60 mx-auto">
                    <RichText
                      text={step.description}
                      strongClassName="font-semibold text-secondary"
                    />
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
